export default class RemoveToast {
  constructor(context) {
    this.context = context;
  }

  run(id) {
    let toast = this.context.stores.toasts.findBy({ id });

    if (toast) {
      this.context.stores.toasts.remove(id);
    }
  }

  static schedule(context, { id, timeout }) {
    return context.scheduler.executeIn(timeout || REMOVE_TOAST_DELAY_MILLISECONDS, id, this, id);
  }
}

const REMOVE_TOAST_DELAY_MILLISECONDS = 5000;



// WEBPACK FOOTER //
// ./src/scripts/application/actions/toast/remove_toast.js